import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ErrorFilled = createSvgIcon(
  <path d="M23 1H1v22h22V1Zm-9.9 5.133V14.2h-2.2V6.133h2.2Zm0 10.634a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0Z" />,
  'ErrorFilled'
);

export { ErrorFilled };